import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import * as React from "react";
import { useState } from "react";
import { Button, Create, SelectInput, TextInput, Toolbar, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { Separator } from "../../../../src/Components/Separator";
import { SectionTitle } from "../../../../src/Components/SectionTitle";
import { NffReportExclusionPnPostModel } from "./Model/NffReportExclusionPnModel";
import { ThyFleetTypes } from "../../../../src/Constants/Constant";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const NffReportExclusionPnCreate = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [customerCodeList, setCustomerCodeList] = useState<any>([]);

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  const GetCustomerCodeList = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerName", order: "ASC" },
        filter: {},
      })
      .then(response => {
        // Create a map to deduplicate by customerCode
        const customerMap = new Map();

        response?.data?.forEach(item => {
          if (!customerMap.has(item.customerCode)) {
            customerMap.set(item.customerCode, {
              customerCode: item.customerCode,
              customerName: item.customerCode,
            });
          }
        });

        // Convert map to array and add THY-C at the beginning
        const customerCodes = Array.from(customerMap.values());
        setCustomerCodeList(customerCodes);
      })
      .catch(error => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    GetCustomerCodeList();
  }, []);

  const CreateNffReportExclusionPnButtonClick = e => {
    CreateNffReportExclusionPn(e);
  };

  const CreateNffReportExclusionPn = async e => {
    let createModel: NffReportExclusionPnPostModel = new NffReportExclusionPnPostModel();
    createModel.Pn = e.pn;
    createModel.Customer = e.customer ?? "";
    createModel.FleetType = e.fleetType ?? "";

    dataProvider
      .postNffReportExclusionPn(createModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        history.push("/reliabilitynffexclusionpns");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={CreateNffReportExclusionPnButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="NFF Report Exclusion PN" />
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="pn" label="Pn" fullWidth variant="outlined" />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <SelectInput
                        source="customer"
                        optionValue="customerCode"
                        optionText="customerName"
                        fullWidth
                        variant="outlined"
                        choices={customerCodeList}
                        label="Customer"
                        allowEmpty
                      />
                      <SelectInput
                        source="fleetType"
                        optionValue="value"
                        optionText="type"
                        fullWidth
                        variant="outlined"
                        choices={ThyFleetTypes}
                        label="Fleet Type"
                        allowEmpty
                      />
                    </Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Exclusion PN is creating!" : "Create Exclusion PN"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default NffReportExclusionPnCreate;
